export default "__VITE_ASSET__e9868fc4__"